import { labeled, numberRequired, stringRequired, guidRequired } from '../../util/joi';
import { schema as ownershipSchema } from './Ownership.schema';

export const schema = (Joi: any, label: string) =>
  Joi.object()
    .keys({
      limit: Joi.number()
    })
    .when('.liabilityType.id', {
      is: 'mortgage_loan',
      then: Joi.object().keys({
        limit: numberRequired(Joi, 1).label(labeled(label, 'Mortgage Loan - Limit')),
        ownership: ownershipSchema(Joi, labeled(label, 'Mortgage Loan -')),
        name: stringRequired(Joi, 1).label(labeled(label, 'Mortgage Loan - Lender')),
        idAsset: guidRequired(Joi, 1).label(labeled(label, 'Mortgage Loan - Linked Asset'))
      })
    })
    .when('.liabilityType.id', {
      is: 'credit_card',
      then: Joi.object({
        limit: numberRequired(Joi, 1).label(labeled(label, 'Credit card - Limit')),
        ownership: ownershipSchema(Joi, labeled(label, 'Credit card -')),
        name: stringRequired(Joi, 1).label(labeled(label, 'Credit card - Lender'))
      })
    })
    .when('.liabilityType.id', {
      is: 'SMSF_loan',
      then: Joi.object({
        limit: numberRequired(Joi, 1).label(labeled(label, 'SMSF loan - Limit')),
        ownership: ownershipSchema(Joi, labeled(label, 'SMSF loan -')),
        name: stringRequired(Joi, 1).label(labeled(label, 'SMSF loan - Lender')),
        idAsset: guidRequired(Joi, 1).label(labeled(label, 'SMSF loan - Linked Asset'))
      })
    })
    .when('.liabilityType.id', {
      is: 'overdraft',
      then: Joi.object({
        ownership: ownershipSchema(Joi, labeled(label, 'Overdraft -')),
        limit: numberRequired(Joi, 1).label(labeled(label, 'Overdraft - Limit')),
        name: stringRequired(Joi, 1).label(labeled(label, 'Overdraft - Lender'))
      })
    })

    .when('.liabilityType.id', {
      is: 'vehicle_loan',
      then: Joi.object({
        ownership: ownershipSchema(Joi, labeled(label, 'Vehicle loan -')),
        balance: numberRequired(Joi, 1).label(labeled(label, 'Vehicle loan - Balance')),
        name: stringRequired(Joi, 1).label(labeled(label, 'Vehicle loan - Lender'))
      })
    })
    .when('.liabilityType.id', {
      is: 'personal_loan',
      then: Joi.object({
        ownership: ownershipSchema(Joi, labeled(label, 'Personal loan -')),
        balance: numberRequired(Joi, 1).label(labeled(label, 'Personal loan - Balance')),
        name: stringRequired(Joi, 1).label(labeled(label, 'Personal loan - Lender'))
      })
    })
    .when('.liabilityType.id', {
      is: 'education_debt',
      then: Joi.object({
        name: Joi.string()
          .required()
          .label(labeled(label, 'Education debt -')),
        ownership: ownershipSchema(Joi, labeled(label, 'Education debt - Details')),
        balance: numberRequired(Joi, 1).label(labeled(label, 'Education debt - Balance'))
      })
    })
    .when('.liabilityType.id', {
      is: 'other',
      then: Joi.object({
        ownership: ownershipSchema(Joi, labeled(label, 'Other -')),
        balance: numberRequired(Joi, 1).label(labeled(label, 'Other - Balance')),
        limit: numberRequired(Joi, 1).label(labeled(label, 'Other loan - Limit')),
        name: stringRequired(Joi, 1).label(labeled(label, 'Other Loan - Lender'))
      })
    })
    .when('.liabilityType.id', {
      is: 'balance_sheet',
      then: Joi.object({
        ownership: ownershipSchema(Joi, labeled(label, 'Balance sheet -')),
        name: stringRequired(Joi, 1).label(labeled(label, 'Balance sheet - Name')),
        balance: numberRequired(Joi, 1).label(labeled(label, 'Balance sheet - Balance'))
      })
    })
    // Other unknown types
    .when('.liabilityType.id', {
      not: Joi.string().valid(
        'SMSF_loan',
        'overdraft',
        'vehicle_loan',
        'personal_loan',
        'education_debt',
        'other',
        'balance_sheet'
      ),
      then: Joi.object({
        ownership: ownershipSchema(Joi, labeled(label, 'Unknown Liability -'))
      })
    });

export default {
  schema
};
